import React from 'react'
import PropTypes from 'prop-types'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import {
    Field,
    reduxForm
} from 'redux-form'
import {
    connect
} from 'react-redux'
import {
    withStyles, MenuItem
} from '@material-ui/core'
import {
    defaultFont
} from '../../assets/jss/common-style'
import {
    renderTextField,
    renderDatePicker,
    renderSelect,
    renderMultipleSelect,
    renderEditor
} from './RenderComponent'
import {
    getJobDetail
} from '../../actions/JobActions'
import {
    CONTRACT,
    BENEFITS,
} from '../../utils/CommonConstant'
import MomentUtils from '@date-io/moment'
import {
    MuiPickersUtilsProvider
} from 'material-ui-pickers'
import '../../assets/css/datePicker.css'

let AdminJobDetailForm = ({ ...props }) => {

    const {
        classes,
        entities,
        category_list,
        category,
        benefits,
        type,
        edit,
        description,
        requirements
    } = props

    return (
        <form className={classes.form}>

            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="title"
                        label="Position Title"
                        disabled={!edit}
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="entity"
                        label="Entity"
                        disabled={!edit}
                        component={renderSelect}
                        style={classes.input}
                        label_width={50}
                    >
                        <MenuItem value="Select Entity" />
                        {
                            Object.keys(entities).map((entity, key) =>
                                <MenuItem value={entity} key={key}>
                                    {
                                        entity
                                    }
                                </MenuItem>
                            )
                        }
                    </Field>
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="location"
                        label="Location"
                        disabled={!edit}
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="department"
                        label="Department"
                        disabled={!edit}
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="salary.min.amount"
                        label="Minmum salary"
                        disabled={!edit}
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Field
                        name="salary.max.amount"
                        label="Maximum Salary"
                        disabled={!edit}
                        component={renderTextField}
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <Field
                            name="close_date"
                            label="Close Date"
                            disabled={!edit}
                            component={renderDatePicker}
                            className="date-picker"
                        />
                    </MuiPickersUtilsProvider>
                </GridItem>


                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="contract.type"
                        label="Job Type"
                        disabled={!edit}
                        component={renderSelect}
                        style={classes.input}
                        label_width={75}
                    >
                        {
                            CONTRACT.map((item, key) =>
                                <MenuItem value={item.value} key={key}>
                                    {
                                        item.name
                                    }
                                </MenuItem>
                            )
                        }
                    </Field>
                </GridItem>

                {
                    type !== 'full' && (

                        <GridItem xs={12} sm={12} md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <Field
                                    name="contract.from"
                                    label="Start Date"
                                    disabled={!edit}
                                    component={renderDatePicker}
                                    style={classes.input}
                                    className="date-picker"
                                />
                            </MuiPickersUtilsProvider>
                        </GridItem>
                    )
                }
                {
                    type !== 'full' && (
                        <GridItem xs={12} sm={12} md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <Field
                                    name="contract.to"
                                    label="End Date"
                                    disabled={!edit}
                                    component={renderDatePicker}
                                    className="date-picker"
                                />
                            </MuiPickersUtilsProvider>
                        </GridItem>

                    )
                }

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="category"
                        label="Job Category"
                        disabled={!edit}
                        component={renderMultipleSelect}
                        style={classes.input}
                        selected_value={category === undefined ? [] : category}
                    >
                        {
                            category_list.map((item, key) =>
                                <MenuItem value={item} key={key}>
                                    {
                                        item
                                    }
                                </MenuItem>
                            )
                        }

                    </Field>

                </GridItem>



                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="description"
                        label="Description"
                        disabled={!edit}
                        init_value={description}
                        component={renderEditor}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="requirements"
                        label="Requirments"
                        disabled={!edit}
                        init_value={requirements}
                        component={renderEditor}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="benefits"
                        label="Benefits"
                        disabled={!edit}
                        component={renderMultipleSelect}
                        style={classes.input}
                        selected_value={benefits === undefined ? [] : benefits}
                    >
                        {
                            BENEFITS.map((item, key) =>
                                <MenuItem value={item} key={key}>
                                    {
                                        item
                                    }
                                </MenuItem>
                            )
                        }

                    </Field>
                </GridItem>

            </GridContainer>

        </form>
    )

}
const styles = ({
    form: {
        width: "65%",
    },
    input: {
        ...defaultFont,
        marginTop: "20px",
        color: "#AAAAAA !important",
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "2",
        maxHeight: "50px",
        borderRadius: "5px 5px 5px 5px",
        boxShadow: "rgba(0, 0, 0, 0.35)",
        margin: "15px auto"
    }
})

AdminJobDetailForm.propTypes = {
    classes: PropTypes.object.isRequired
}

AdminJobDetailForm = reduxForm({
    form: "AdminJobDetail",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
})(AdminJobDetailForm)

AdminJobDetailForm = connect(
    state => ({
        initialValues: state.jobs.detail,
    }),
    {
        getJobDetail
    }
)(AdminJobDetailForm)

export default withStyles(styles)(AdminJobDetailForm);